<ms-colored-icon *ngFor="let id of regionIds" iconClass="country-icon c{{ id }}"></ms-colored-icon>
